import assessments from './assessments';
import * as enTranslations from './en.json';

export default {
  ...enTranslations,
  ...assessments,
};
